export const LOGIN_STEPS = {
  LOGIN: 'LOGIN',
  MFA_EMAIL: 'MFA_EMAIL',
} as const;

export type LOGIN_STEPS = (typeof LOGIN_STEPS)[keyof typeof LOGIN_STEPS];
